import React, {useState,useRef} from "react";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import {getSessionState} from "../../hooks/useSessionState";
import Filtro from "../../shared/componentes/filtro";
import FieldCalendarRange from "../../shared/controls/fieldCalendarRange";
import FieldMultiSelect from "../../shared/controls/fieldMultiSelect";
import {Sidebar} from "primereact/sidebar";
import IncidenciasCobrosDetalle from "./incidenciasCobrosDetalle";
import useApiIncidenciasCobros from "../../api/administracion/useApiIncidenciasCobros";

const MovimientosIncidenciasCobros = ({esSeccionAutorizar, soloLectura, esquemaPagos}) => {
    const filtroKey = 'FiltroIncidenciasCobros'
    const defaultFilter = {
        fechas: [new Date(), new Date()]       
    };
    const [datos, setDatos] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [movimientoId, setMovimientoId] = useState(false);
    const api = useApiIncidenciasCobros();
    const [, setFiltro] = useState(null);
    const filtroRef = useRef(null);
    async function buscar(filtroBusqueda, paramsApi) {
        setFiltro(filtroBusqueda);
        filtroRef.current = filtroBusqueda;  
        agGridHelper.showLoad(gridApi, paramsApi, true);
        setDatos(await api.filtrar(obtenerFiltro(filtroBusqueda)));
        agGridHelper.hideLoad(gridApi, paramsApi, false);
    }

    const obtenerFiltro = (filtro) => {
        filtro = filtro ?? getSessionState(filtroKey);  
        let esquema = filtro.esquemaPagos ? filtro.esquemaPagos : esquemaPagos;
        return { ...filtro, porAutorizar: esSeccionAutorizar, esquemaPagos: esquema };
    }

    const onGridReady = async (params) => {
        setGridApi(params.api);
    };

    async function onSave() {
        setSidebarVisible(false);
        await buscar();
    }

    const verMovimiento = (id) => {
        setSidebarVisible(true);
        setMovimientoId(id);
    };

    function exportar() {      
        api.excel();
    }
    const ButtonsHeader = () => {
        return (
            <div className="ag-grid header-icons">
                <ButtonIcon title="Descargar" onClick={exportar} iconName="BiDownload"/>
            </div>
        );
    };

    const RowButtons = ({data}) => (
        <div className="ag-grid row-icons">
            <button className="btn btn-link btn-sm" title={'Ver'} onClick={() => verMovimiento(data.id)}>
                Ver
            </button>
        </div>
    );

    return (
        <>


              <Filtro  defaultValue={defaultFilter} filtroKey={filtroKey} handleSubmit={buscar} classButtons="field-iconos btn-group">
                <Filtros />
            </Filtro>


            <Sidebar visible={sidebarVisible} position="right" dismissable={false}   className="p-sidebar-xl" 
                     onHide={() => setSidebarVisible(false)}>
                
                <IncidenciasCobrosDetalle movimientoId={movimientoId} onSaved={onSave} 
                                    close={() => setSidebarVisible(false)} 
                                    soloLectura={soloLectura}/>            
            </Sidebar>

               <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    frameworkComponents={
                        {
                            buttonsHeader: ButtonsHeader,
                            rowButtons: RowButtons,
                            goToDetail: agGridHelper.GoToDetailFormatter,
                            dateFormatter: agGridHelper.DateTimeFormatter,
                        }
                    }
                    onGridReady={onGridReady}
                    rowData={datos}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowHeight={35}
                >
                    <AgGridColumn flex={2} minWidth={200} field="fechaSolicitud" headerName="FECHA SOLICITUD"
                                  cellRenderer="dateFormatter"/>                                     
                    <AgGridColumn field="empleado" headerName="EMPLEADO" flex={3} minWidth={350} cellClass={'left'}
                                  headerClass={'left'}/>                
                    <AgGridColumn maxWidth={120} field="monto" headerName="MONTO" cellStyle={{textAlign: "right"}}
                                  valueFormatter={agGridHelper.currencyFormatter}/>
                    <AgGridColumn field="concepto" headerName="CONCEPTO" flex={3} minWidth={180} cellStyle={{textAlign: "left"}}/>
                    <AgGridColumn field="solicitadoPor" headerName="SOLICITADO POR" flex={3} minWidth={300} cellStyle={{textAlign: "left"}}/>
                    <AgGridColumn maxWidth={100} field="estatus" headerName="ESTATUS" flex={3} minWidth={200} />
                    <AgGridColumn field="exhibiciones" headerName="Exhibiciones" cellStyle={{ textAlign: "center" }} maxWidth={130} />
                    <AgGridColumn field="liquidado" headerName="Liquidado" cellStyle={{ textAlign: "center" }}flex={3} minWidth={100}  />

                    <AgGridColumn maxWidth={80}
                                  headerName="VER"
                                  cellRenderer="rowButtons"
                                  pinned={'right'}
                                  cellClass={'left'}
                                  headerComponent="buttonsHeader"/>
                </AgGridReact>
               </div>
            
        </>
    )
};

const Filtros = ({filtro, onChange}) => {
    return (
        <>
            <FieldMultiSelect name="empleados" source="empleados" label="Empleado" colLg={2} colMd={3}
                              value={filtro.empleados} onChange={onChange} showFilter valueAsId={true}/>

       
            <FieldCalendarRange name="fechas" label="Fechas" colLg={2} colMd={3} value={filtro.fechas}
                                onChange={onChange}/>

        </>
    )
};

export default MovimientosIncidenciasCobros;
